export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70a3746bf6cc932ba9607b970446b3e1d53f1414f1&name=pushAdClickData!'